import React from 'react';
import { motion } from 'framer-motion';
import { ParticleField } from '../shared/ParticleField';
import { ChevronDownIcon } from 'lucide-react';
import { HERO_BACKGROUND_IMAGE, HERO_BACKGROUND_IMAGE_MOBILE } from '../../data/signs';
export function Hero() {
  const scrollToGrid = () => {
    document.getElementById('sign-grid')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full h-screen flex items-center justify-center overflow-hidden bg-cosmic-black" data-id="element-95">
      {/* Background image — responsive mobile/desktop swap */}
      <div className="absolute inset-0 z-0" data-id="element-96">
        <picture data-id="element-97">
          <source media="(max-width: 767px)" srcSet={HERO_BACKGROUND_IMAGE_MOBILE} data-id="element-98" />
          <img src={HERO_BACKGROUND_IMAGE} alt="LOS 12 — Los Doce Reinos" className="w-full h-full object-cover" style={{
          opacity: 0.65
        }} loading="eager" decoding="async"
        // @ts-ignore - fetchpriority is valid HTML attribute
        fetchpriority="high" data-id="element-99" />
        </picture>

        {/* Lighter dark overlay for legibility (reduced from previous) */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(5,5,8,0.45) 0%, rgba(5,5,8,0.25) 50%, rgba(5,5,8,0.65) 100%)'
      }} data-id="element-100" />
        {/* Soft vignette */}
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at center, transparent 0%, rgba(5,5,8,0.35) 85%, rgba(5,5,8,0.85) 100%)'
      }} data-id="element-101" />
      </div>

      {/* Particle layer — lighter density for mobile performance */}
      <ParticleField type="cosmic" density={25} data-id="element-102" />

      {/* Constellation overlay — desktop only to save mobile rendering cost */}
      <div className="hidden md:block absolute inset-0 opacity-10 z-[1] pointer-events-none" data-id="element-103">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-104">
          <defs data-id="element-105">
            <pattern id="constellation" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse" data-id="element-106">
              <circle cx="10" cy="10" r="1" fill="#C9A84C" data-id="element-107" />
              <circle cx="150" cy="50" r="1" fill="#C9A84C" data-id="element-108" />
              <circle cx="80" cy="120" r="1" fill="#C9A84C" data-id="element-109" />
              <circle cx="180" cy="180" r="1" fill="#C9A84C" data-id="element-110" />
              <line x1="10" y1="10" x2="150" y2="50" stroke="#C9A84C" strokeWidth="0.5" opacity="0.3" data-id="element-111" />
              <line x1="150" y1="50" x2="80" y2="120" stroke="#C9A84C" strokeWidth="0.5" opacity="0.3" data-id="element-112" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#constellation)" data-id="element-113" />
        </svg>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-115">
          <h1 className="text-7xl md:text-9xl font-serif font-bold mb-6 tracking-widest" style={{
          color: '#F5F5F0',
          textShadow: '0 0 40px rgba(201, 168, 76, 0.7), 0 4px 30px rgba(0,0,0,0.9)'
        }} data-id="element-116">
            LOS 12
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-gold-light text-lg md:text-xl mb-12 tracking-wide" style={{
        textShadow: '0 2px 20px rgba(0,0,0,0.9)'
      }} data-id="element-117">
          Doce entidades. Doce energías. Doce reinos.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1
      }} className="space-y-6" data-id="element-118">
          <h2 className="text-3xl md:text-5xl font-serif font-semibold text-white mb-4" style={{
          textShadow: '0 2px 30px rgba(0,0,0,0.95)'
        }} data-id="element-119">
            Selecciona tu signo.
          </h2>
          <p className="text-gray-200 text-base md:text-lg max-w-2xl mx-auto leading-relaxed" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.9)'
        }} data-id="element-120">
            Cada entidad representa una naturaleza distinta. Entra a tu reino y
            descubre el arquetipo que vive detrás de tu signo.
          </p>
        </motion.div>

        <motion.button initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.4
      }} onClick={scrollToGrid} className="mt-12 px-8 py-4 bg-cosmic-black/40 border-2 border-gold-primary text-gold-light font-medium rounded-lg hover:bg-gold-primary hover:text-cosmic-black transition-all duration-300" whileHover={{
        scale: 1.05,
        boxShadow: '0 0 30px rgba(201, 168, 76, 0.5)'
      }} whileTap={{
        scale: 0.95
      }} data-id="element-121">
          Explora los 12 arquetipos
        </motion.button>

        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="mt-16" data-id="element-122">
          <ChevronDownIcon size={32} className="mx-auto text-gold-primary opacity-60" data-id="element-123" />
        </motion.div>
      </div>
    </section>;
}